module.exports = __webpack_public_path__ + "static/media/preimage.d54fb91b.svg";